var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57812 9.25039H9.08438V12.1754H5.57812V9.25039ZM5.57812 16.066H9.08438V13.141H5.57812V16.066ZM5.57812 19.9473H9.08438V17.0223H5.57812V19.9473ZM10.125 16.066H13.6219V13.141H10.1156V16.066H10.125ZM10.125 19.9473H13.6219V17.0223H10.1156V19.9473H10.125ZM14.6719 17.0223V19.9473H18.1781V17.0223H14.6719ZM23.7469 5.61289L11.8688 0.0253906L0 5.63164L0.740625 7.17852L2.25 6.45664V19.9566H3.95625V6.40039H19.8V19.9754H21.5063V6.47539L23.0156 7.17852L23.7469 5.61289Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/Warehouse.701433c7f20d2bbf6005a122292fd835.svg";
export { ForwardRef as ReactComponent };